function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-10{fill:none;stroke:#3e4c57;stroke-linecap:round;stroke-linejoin:round;}.cls-22{fill:#3e4c57;}\n.cls-10 {\n    transition: all 0.4s ease-out;\n}\nsvg:hover .cls-10 { \n    stroke: #FF9900;\n}\n"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M28.69,11.71V28.28A1.72,1.72,0,0,1,27,30H12a1.71,1.71,0,0,1-1.72-1.72v-4H21.14a1,1,0,0,0,1-1V17.16a1,1,0,0,0-1-1H10.29V7.72A1.71,1.71,0,0,1,12,6H22.63l.1,5.71h6Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M22.63,6l6,5.69Z"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 7.31,
  y: 16.13,
  width: 14.86,
  height: 8.19,
  rx: 1.03
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-22",
  d: "M12.08,18.65a1.86,1.86,0,0,0-.77-.15H9.87V22h.8V21h.64a2,2,0,0,0,.77-.14,1.16,1.16,0,0,0,.53-.44,1.36,1.36,0,0,0,0-1.35A1.2,1.2,0,0,0,12.08,18.65ZM12,19.76a.49.49,0,0,1-.16.4.89.89,0,0,1-.54.14h-.61V19.21h.61a.83.83,0,0,1,.54.15A.48.48,0,0,1,12,19.76Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-22",
  d: "M15.69,18.71a2.16,2.16,0,0,0-1-.21H13.2V22h1.52a2.16,2.16,0,0,0,1-.21,1.59,1.59,0,0,0,.67-.61,1.68,1.68,0,0,0,.24-.9,1.72,1.72,0,0,0-.24-.91A1.59,1.59,0,0,0,15.69,18.71Zm-1.69.5h.69a1.22,1.22,0,0,1,.59.13.92.92,0,0,1,.38.35,1.13,1.13,0,0,1,.13.54,1.2,1.2,0,0,1-.13.54,1,1,0,0,1-.38.35,1.35,1.35,0,0,1-.59.12H14Z"
});

var _ref8 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-22",
  points: "19.62 19.2 19.62 18.5 17.04 18.5 17.04 21.95 17.84 21.95 17.84 20.71 19.42 20.71 19.42 20 17.84 20 17.84 19.2 19.62 19.2"
});

var SvgPdfSymbol = function SvgPdfSymbol(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    width: "35px",
    height: "25px",
    "data-name": "Layer 1",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPdfSymbol, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pdf-symbol.d6b8d8d6.svg";
export { ForwardRef as ReactComponent };